import { GSEndpoint } from "../models/endpoint";
import { User } from "../models/user";
import { ProjectI, Project } from "../models/project";

export class GetProjects extends GSEndpoint<{}, {[id: string]: ProjectI[]}> {
    constructor() {
        super("projects", "GET", []);
    }

    override async request(user: Partial<User>): Promise<Project[]> {
        const res: {[id: string]: ProjectI[]} = await this.makeRequest({}, user);
        return res.projects.map(p => Project.fromObject(p));
    }
}

export class PostProjects extends GSEndpoint<ProjectI> {
    constructor() {
        super("projects", "POST", ["user:maintain"]);
    }

    override async request(project: ProjectI, user: Partial<User>): Promise<void> {
        project.count = project.count ?? 0;
        await this.makeRequest(project, user);
    }
}
